export const environment = {
  production: false,
  envname: 'ACC',
  BASE_API_URL: '',
  FETCH_NOISE_TYPE_URL: 'kiid2majxk.execute-api.ap-northeast-1.amazonaws.com/acc',
  S3_AUDIO_URL: 'https://noise-upload-acc.s3.ap-northeast-1.amazonaws.com',
  GRAFANA_URL: 'http://noise-grafana.samsunghrm.com',
  SSO_CLIENT_ID: '24ddc97e-b64e-472a-b3f3-5c40a43604ab',
  SSO_REDIRECT_URI: window.location.origin + '/?sso',
  SSO_URL: 'https://sts.secsso.net/adfs/oauth2/authorize/wia',
  SSO_LOGOUT_URL: 'https://sts.secsso.net/adfs/oauth2/logout',
  BACKEND_API_URL: 'https://noise-acc-backend.samsunghrm.com',
};
